import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function VisitTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: location.pathname, referrer: document.referrer }),
      credentials: 'include',
    }).catch(() => {
      // Analytics failures should never affect the user experience
    });
  }, [location.pathname]);

  return null;
}
